







































































































import Vue, { PropType } from 'vue';
// import { BoothData } from '@/modules/exhibitor/booth';
// import {
//   createLineupGroupTitle,
//   createLineupItems,
//   Lineup,
// } from '@/modules/exhibitor/lineup';
//
// import { options } from 'mostra';

import {
  Item,
  options,
  Lineup,
  lineup as lineupM,
  BoothData,
} from 'mostra';
import { v4 } from 'uuid';

const {
  createLineupGroupTitle,
  createLineupItems,
  createLineupGroupDescription,
} = lineupM;

// import { itemCategories } from '@/modules/options';
// import { options } from '@/modules/options';
// import { Item } from '@/modules/exhibitor/item';

const generateListKey = () => v4();

type BoothLineupItem = {
  id: string,
  lineup: Lineup,
}

interface DataType {
  categoryOptions: object[];
  isFrameSelectMode: boolean;
  selectedLineupLayout: number | null;
  isSelectModalOpen: boolean;
  lineupItemOptions: Item[];
  selectedLineupItemIds: string[];
  blockIndex: number;
  maxLineupItemIndex: number;
  currentIndex: number;
  listLength: number;
  maxDisplayedItemLength: number;
  pagerLength: number;
  maxPagerLength: number;
  listItems: Item[];
  pagerItems: number[];
}

export default Vue.extend({
  name: 'GBoothLineupForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<BoothData>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      categoryOptions: [
        { text: '全てのカテゴリ', value: 0 },
        ...options.itemCategories,
      ],
      isFrameSelectMode: false,
      selectedLineupLayout: null,
      isSelectModalOpen: false,
      selectedLineupItemIds: [], // MEMO lineup毎に商品を選択ボタンを押した時に更新
      lineupItemOptions: [],
      blockIndex: 0,
      maxLineupItemIndex: 0,
      currentIndex: 1,
      listLength: 0,
      maxDisplayedItemLength: 30,
      pagerLength: 0,
      maxPagerLength: 8,
      listItems: [],
      pagerItems: [],
    };
  },
  computed: {
    lineups(): BoothLineupItem[] {
      return this.booth.lineup.map((lineup: Lineup) => (
        {
          id: generateListKey(),
          lineup: lineup,
        }
      ));
    },
  },
  watch: {
    'booth.items'() {
      this.setLineupItemOptions();
    },
    lineupItemOptions(array: any) {
      if (array) {
        this.listLength = array.length;
        this.pagerLength = Math.ceil(
          array.length / this.maxDisplayedItemLength,
        );
        this.createList(this.currentIndex);
      }
    },
    currentIndex(index: number) {
      this.createList(index);
    },
  },
  methods: {
    // async fetchItems() {
    //   try {
    //     this.loading = true;
    //     // const uid = this.$auth.uid;
    //     this.items = await item.loadsByOwner(this.$auth.cid);
    //   } catch (error: any) {
    //     console.log(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    setMaxLineupItemIndex() {
      const frameType = this.booth.lineup[this.blockIndex].frameType;
      if (frameType === 1) {
        this.maxLineupItemIndex = 3;
        return;
      }
      if (frameType === 2) {
        this.maxLineupItemIndex = 3;
        return;
      }
      if (frameType === 3) {
        this.maxLineupItemIndex = 5;
        return;
      }
      if (frameType === 6) {
        this.maxLineupItemIndex = 2;
        return;
      }
      if (frameType === 7) {
        this.maxLineupItemIndex = 1;
        return;
      }
      if (frameType === 101) {
        this.maxLineupItemIndex = 3;
        return;
      }
      if (frameType === 102) {
        this.maxLineupItemIndex = 2;
        return;
      }
      if (frameType === 103) {
        this.maxLineupItemIndex = 1;
        return;
      }
      this.maxLineupItemIndex = 0;
    },
    setLineupItemOptions() {
      const selectedItemIds = this.booth.items;
      this.lineupItemOptions = this.items.filter(
        ({ id }) => id && selectedItemIds.includes(id),
      );
      this.listItems = this.lineupItemOptions;
    },
    generateListKey() {
      return v4();
    },
    addParts() {
      // MEMO レイアウトが選択されていない状態ではリターン
      if (!this.selectedLineupLayout) return;
      // MEMO 選択されたレイアウトがグループタイトル（4）かをチェックする
      const newLineupBlock = (() => {
        switch (this.selectedLineupLayout) {
          case 4: return createLineupGroupTitle();
          case 5: return createLineupGroupDescription();
          default: return createLineupItems(this.selectedLineupLayout ?? 1);
        }
      })();
      // MEMO 新しく作ったlineupを追加
      this.booth.lineup = [...this.booth.lineup, newLineupBlock];
      // MEMO レイアウトの選択状態を戻す
      this.selectedLineupLayout = null;
      this.switchFrameSelectMode();
    },
    onRemoveParts(targetIndex: number) {
      return () => {
        this.booth.lineup.splice(targetIndex, 1);
      };
    },
    onSwapLineupPosition(mode: 'up' | 'down', targetIndex: number) {
      return () => {
        let swapTargetIndex = 0;
        if (mode === 'up') {
          if (targetIndex === 0) return;
          swapTargetIndex = targetIndex - 1;
        }
        if (mode === 'down') {
          if (targetIndex === this.booth.lineup.length - 1) return;
          swapTargetIndex = targetIndex + 1;
        }
        const copiedPickups = [...this.booth.lineup];
        copiedPickups[swapTargetIndex] = this.booth.lineup[targetIndex];
        copiedPickups[targetIndex] = this.booth.lineup[swapTargetIndex];
        this.booth.lineup = copiedPickups;
      };
    },
    onDeleteLineupItem(targetIndex: number, lineupIndex: number) {
      return () => {
        const lineupBlock: Lineup = this.booth.lineup[lineupIndex];
        if (!lineupBlock.itemIds) return;
        lineupBlock.itemIds.splice(targetIndex, 1);
      };
    },
    onSwapLineupItemPosition(
      mode: 'up' | 'down',
      targetIndex: number,
      lineupIndex: number,
    ) {
      return () => {
        let swapTargetIndex = 0;
        const targetLineup: Lineup = this.booth.lineup[lineupIndex];
        if (!targetLineup.itemIds) return;
        if (mode === 'up') {
          if (targetIndex === 0) return;
          swapTargetIndex = targetIndex - 1;
        }
        if (mode === 'down') {
          if (targetLineup.itemIds.length === targetIndex + 1) return;
          swapTargetIndex = targetIndex + 1;
        }
        const copiedLineups = [...targetLineup.itemIds];
        copiedLineups[swapTargetIndex] = targetLineup.itemIds[targetIndex];
        copiedLineups[targetIndex] = targetLineup.itemIds[swapTargetIndex];
        this.booth.lineup[lineupIndex].itemIds = copiedLineups;
      };
    },
    onClickSelectItem(targetIndex: number) {
      return () => {
        const targetLineup: Lineup = this.booth.lineup[targetIndex];
        if (!targetLineup.itemIds) return;
        this.blockIndex = targetIndex;
        this.selectedLineupItemIds = [...targetLineup.itemIds];
        this.setMaxLineupItemIndex();
        this.isSelectModalOpen = true;
      };
    },
    onClickSelectDone() {
      this.booth.lineup[this.blockIndex].itemIds = this.selectedLineupItemIds;
      this.onCloseSelectItemModal();
    },
    onCloseSelectItemModal() {
      this.blockIndex = 0;
      this.selectedLineupItemIds = [];
      this.isSelectModalOpen = false;
    },
    switchFrameSelectMode() {
      this.isFrameSelectMode = !this.isFrameSelectMode;
    },
    onSelectLineupLayout(val: number) {
      this.selectedLineupLayout = val;
    },
    onCategoryChange(val: number) {
      const selectedItemIds = this.booth.items;
      if (!val) {
        this.lineupItemOptions = this.items.filter(
          ({ id }) => id && selectedItemIds.includes(id),
        );
      } else {
        const selectedItems = this.items.filter(
          ({ id }) => id && selectedItemIds.includes(id),
        );
        this.lineupItemOptions = selectedItems.filter(
          (itemValue: Item) => val === itemValue.data.category.categoryId,
        );
      }
      this.listItems = this.lineupItemOptions;
      this.currentIndex = 1;
    },
    createList(index: number) {
      const startIndex = (index - 1) * this.maxDisplayedItemLength;
      this.listItems = [];
      for (let i = 0; i < this.maxDisplayedItemLength; i++) {
        if (!this.lineupItemOptions[startIndex + i]) break;
        this.listItems.push(this.lineupItemOptions[startIndex + i]);
      }
    },
    setPagerItems(list: number[]) {
      this.pagerItems = list;
    },
    prevPage() {
      if (this.currentIndex <= 1) return;
      this.currentIndex--;
    },
    changePage(index: number) {
      this.currentIndex = index;
    },
    nextPage() {
      if (this.currentIndex >= this.pagerLength) return;
      this.currentIndex++;
    },
  },
  async mounted() {
    this.setLineupItemOptions();
  },
});
